import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiroCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconGiroCard"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM9 9.5C9 9.22386 8.77614 9 8.5 9H6.5C6.22386 9 6 9.22386 6 9.5C6 9.77614 6.22386 10 6.5 10H8.5C8.77614 10 9 9.77614 9 9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiroCard;
